import { useContext } from 'react';
import { MobxContext } from 'context/store';
import i18n from 'i18next';

const useStore = () => {
  const store = useContext(MobxContext);
  if (store === null) {
    throw new Error(i18n.t('hooks.useStore.noStoreProviderFound'));
  }
  return store;
};

export default useStore;
